import type { GetPrebidUserIds, PrebidIdPartnerConfig } from "./IdPartners";

/**
 * @see https://docs.prebid.org/dev-docs/modules/userid-submodules/id5.html
 */
export const id5Partner: GetPrebidUserIds = (config: PrebidIdPartnerConfig) => {
  if (!config.icPrebidId5) {
    return undefined;
  }

  const partnerConfig = {
    name: "id5Id",
    params: {
      partner: 1139,
    },
    storage: {
      type: "html5",
      name: "id5id",
      expires: 90,
      refreshInSeconds: 8 * 3600,
    },
  } satisfies PrebidUserIds;

  if (config.icPrebidId5ExternalModule) {
    Object.assign(partnerConfig.params, {
      externalModuleUrl: "https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js",
    });
  }

  return partnerConfig;
};
